import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ImportFileType } from '@/coreDomainsModule/entities/unmanagedBusiness';
import { useUnmanagedBusinessStore } from '../pages/unmanagedBusinessStore';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'FileTypeSelectButton',
  props: {
    fileType: {}
  },
  setup(__props: any) {

const props = __props;

const store = useUnmanagedBusinessStore();
const { changeSelectedFileType, fetchUnmanagedBusinesses } = store;
const { state } = storeToRefs(store);

const isActive = computed(() => state.value.selectedFileType === props.fileType);

/**
 * ファイルタイプボタンをクリックした時の処理
 * @param fileType - ファイルタイプ
 */
const onClickFileTypeButton = async (fileType: ImportFileType) => {
  changeSelectedFileType(props.fileType);
  await fetchUnmanagedBusinesses();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      class: _normalizeClass(["file-type-button", { 'file-type-button--inactive': !isActive.value }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (onClickFileTypeButton(_ctx.fileType)))
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ]))
}
}

})